jQuery(function ($) {
    
    let isLoading = false;

    function updateActiveFilters() {
        const industry = $('#filter-industry').val();
        const brands = $('#filter-brands').val();
        const country = $('#filter-country').val();
        const search = $('#distributor-search').val();
        
        const $tagsContainer = $('#distributors-filter-tags');
        const $resetButton = $('#reset-distributors-filters');
        
        $tagsContainer.empty();
        
        let hasFilters = false;
        
        // Add industry tag
        if (industry) {
            hasFilters = true;
            const label = $('#filter-industry option:selected').text();
            $tagsContainer.append(
                `<span class="filter-tag" data-filter="industry">
                    ${label}
                    <button type="button" class="filter-tag__remove" data-filter-type="industry" aria-label="Remove ${label}">×</button>
                </span>`
            );
        }
        
        // Add brands tag
        if (brands) {
            hasFilters = true;
            const label = $('#filter-brands option:selected').text();
            $tagsContainer.append(
                `<span class="filter-tag" data-filter="brands">
                    ${label}
                    <button type="button" class="filter-tag__remove" data-filter-type="brands" aria-label="Remove ${label}">×</button>
                </span>`
            );
        }
        
        // Add country tag
        if (country) {
            hasFilters = true;
            const label = $('#filter-country option:selected').text();
            $tagsContainer.append(
                `<span class="filter-tag" data-filter="country">
                    ${label}
                    <button type="button" class="filter-tag__remove" data-filter-type="country" aria-label="Remove ${label}">×</button>
                </span>`
            );
        }
        
        // Add search tag
        if (search) {
            hasFilters = true;
            $tagsContainer.append(
                `<span class="filter-tag" data-filter="search">
                    Search: "${search}"
                    <button type="button" class="filter-tag__remove" data-filter-type="search" aria-label="Remove search">×</button>
                </span>`
            );
        }
        
        // Show/hide reset button
        $resetButton.toggle(hasFilters);
    }

    function loadDistributors(page = 1) {
        if (isLoading) return;

        isLoading = true;

        const industry = $('#filter-industry').val();
        const brands = $('#filter-brands').val();
        const country = $('#filter-country').val();
        const search = $('#distributor-search').val();

        // Show loading state
        $('#distributors-results').css('opacity', '0.5');

        $.ajax({
            url: distributorsAjax.ajax_url,
            type: 'POST',
            data: {
                action: 'filter_distributors',
                nonce: distributorsAjax.nonce,
                paged: page,
                industry: industry,
                brands: brands,
                country: country,
                search: search,
                lang: $('html').attr('lang') || 'en'
            },
            success: function (response) {
                if (response.success) {
                    $('#distributors-results').html(response.data.html);
                    $('#distributors-results').css('opacity', '1');
                    
                    // Update results count
                    $('#distributors-count-total').text(response.data.found);
                    
                    // Update active filters display
                    updateActiveFilters();
                    
                    // Initialize more/less toggle for new content
                    initMoreToggle();
                    
                    // Scroll to results
                    $('html, body').animate({
                        scrollTop: $('.distributors').offset().top - 100
                    }, 300);
                }
            },
            error: function () {
                console.error('Failed to load distributors');
                $('#distributors-results').css('opacity', '1');
            },
            complete: function () {
                isLoading = false;
            }
        });
    }

    // Handle select changes
    $('#filter-industry, #filter-brands, #filter-country').on('change', function () {
        loadDistributors(1);
    });

    // 

    // Handle reset filters button
    $('#reset-distributors-filters').on('click', function () {
        $('#filter-industry').val('');
        $('#filter-brands').val('');
        $('#filter-country').val('');
        $('#distributor-search').val('');
        loadDistributors(1);
    });

    // Handle individual filter tag removal
    $(document).on('click', '.filter-tag__remove', function () {
        const filterType = $(this).data('filter-type');
        
        switch (filterType) {
            case 'industry':
                $('#filter-industry').val('');
                break;
            case 'brands':
                $('#filter-brands').val('');
                break;
            case 'country':
                $('#filter-country').val('');
                break;
            case 'search':
                $('#distributor-search').val('');
                break;
        }
        
        loadDistributors(1);
    });

    // Handle search with debounce
    let searchTimeout;
    $('#distributor-search').on('keyup', function () {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function () {
            loadDistributors(1);
        }, 500);
    });

    // Handle pagination clicks
    $(document).on('click', '.distributors__pagination a', function (e) {
        e.preventDefault();
        
        const url = $(this).attr('href');
        let page = 1;
        
        // Try to get page from query string (?paged=2)
        const queryString = url.split('?')[1];
        if (queryString) {
            const urlParams = new URLSearchParams(queryString);
            if (urlParams.has('paged')) {
                page = parseInt(urlParams.get('paged'));
            }
        }
        
        // If not found in query string, try path format (/page/2/)
        if (page === 1) {
            const pageMatch = url.match(/\/page\/(\d+)/);
            if (pageMatch) {
                page = parseInt(pageMatch[1]);
            }
        }
        
        loadDistributors(page);
    });

    // More/Less toggle functionality
    function initMoreToggle() {
        // Small delay to ensure DOM is fully rendered and heights are calculated
        setTimeout(function() {
            $('.distributor-card__info').each(function() {
                const $info = $(this);
                const $list = $info.find('.distributor-card__info__list');
                const $moreBtn = $info.find('.distributor-card__info__more');
                
                // Check if content overflows (more than one line)
                // Add 2px tolerance to account for sub-pixel rendering differences
                if ($list[0].scrollHeight > $list.outerHeight() + 2) {
                    $moreBtn.removeClass('hidden');
                } else {
                    $moreBtn.addClass('hidden');
                }
            });
        }, 50);
    }

    // Handle "More" click
    $(document).on('click', '.distributor-card__info__more', function() {
        const $btn = $(this);
        const $list = $btn.siblings('.distributor-card__info__list');
        const moreText = $btn.data('more-text') || 'More +';
        const lessText = $btn.data('less-text') || 'Less';
        
        if ($list.hasClass('expanded')) {
            $list.removeClass('expanded');
            $btn.text(moreText);
        } else {
            $list.addClass('expanded');
            $btn.text(lessText);
        }
    });
    
    // Initialize active filters display on page load
    updateActiveFilters();
    
    // Initialize more/less toggle on page load
    initMoreToggle();

});
